import React from "react";
import "../styles/Vision.css";

const Vision: React.FC = () => {
  return (
    <section id="vision" className="vision">
      <div className="container">
        <h2>Our Vision</h2>
        <div className="vision-content">
          <div className="vision-image">
            <img src="/images/vision.avif" alt="Parwah Industries Vision" />
          </div>
          <div className="vision-text">
            <h3>Building a Global Legacy</h3>
            <p>
              At Parwah Industries, we envision a future where quality and
              innovation transcend borders. Our commitment to excellence drives
              us to be the leading force in connecting premium brands with
              discerning customers worldwide.
            </p>
            <p>
              We strive to be the bridge between exceptional products and global
              markets, fostering sustainable growth while maintaining the
              highest standards of quality and customer satisfaction.
            </p>
            <div className="vision-values">
              <div className="value-item">
                <h4>Innovation</h4>
                <p>Continuously evolving and adapting to market needs</p>
              </div>
              <div className="value-item">
                <h4>Quality</h4>
                <p>Uncompromising commitment to excellence</p>
              </div>
              <div className="value-item">
                <h4>Global Reach</h4>
                <p>Expanding our presence across international markets</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
